import React from 'react';

export const setDropdownState = (isOpen: boolean, setState: React.Dispatch<React.SetStateAction<boolean>>) => {
    setState(isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';

    const overlay = document.querySelector('.overlay');

    overlay?.classList.toggle('d-none', !isOpen);
};
